import { Button, Typography } from "@visma-netvisor/react-component-library";
import { useTranslation } from "react-i18next";
import { sendTag } from "../../analytics";
import { COMPANY_CREATION_URL, PRICING_PAGE_URL } from "../../constants";
import styled from "styled-components";

type Props = {
  organizationIdentifier: string | undefined;
  failureKind: "auth" | "network" | "restart";
};

const CompanyCreationOrderRetry = ({
  organizationIdentifier,
  failureKind,
}: Props) => {
  const { t } = useTranslation();
  sendTag({
    status:
      failureKind === "auth"
        ? "authExpired"
        : failureKind === "network"
          ? "orderRetryNetwork"
          : "orderRestartNoPayload",
  });

  const handleContinue = () => {
    if (failureKind === "restart") {
      window.location.href = PRICING_PAGE_URL;
      return;
    }
    if (failureKind === "auth") {
      sessionStorage.setItem(`reauthAttempted:${organizationIdentifier ?? "_"}`, "1");
    }
    // organizationIdentifier must be passed to /v1/login so Telia's callback can attach it as a claim; without it the order controller rejects with 401 again.
    const url = organizationIdentifier
      ? `${COMPANY_CREATION_URL}/v1/login?organizationIdentifier=${encodeURIComponent(organizationIdentifier)}`
      : `${COMPANY_CREATION_URL}/v1/login`;
    window.location.href = url;
  };

  const descriptionKey =
    failureKind === "auth"
      ? "OnlineStatus.OrderRetryAuthDescription"
      : failureKind === "network"
        ? "OnlineStatus.OrderRetryNetworkDescription"
        : "OnlineStatus.OrderRestartDescription";

  const buttonKey =
    failureKind === "restart"
      ? "OnlineStatus.ReturnToPurchase"
      : "OnlineStatus.Continue";

  return (
    <>
      <CenteredTypography variant="headingH4Regular">
        {t("OnlineStatus.OrderRetryTitle")}
      </CenteredTypography>
      <CenteredPrimaryTypography color="primary">
        {t(descriptionKey)}
      </CenteredPrimaryTypography>
      <ButtonContainer>
        <Button onClick={handleContinue}>{t(buttonKey)}</Button>
      </ButtonContainer>
    </>
  );
};

export default CompanyCreationOrderRetry;

const CenteredTypography = styled(Typography)`
  text-align: center;
  margin-top: 24px;
`;

const CenteredPrimaryTypography = styled(Typography)`
  text-align: center;
  padding-top: 24px;
  margin-left: 20%;
  margin-right: 20%;

  @media (max-width: 768px) {
    margin-left: 5%;
    margin-right: 5%;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;
